import { OffersFacade } from '@/_store/offers/offers.facade';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MobileDialogService } from '@/common/mobile-dialog/mobile-dialog.service';

@Component({
	selector: 'app-top-search-filter-items-mobile-footer',
	templateUrl: './top-search-filter-items-mobile-footer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSearchFilterItemsMobileFooterComponent {
	private readonly mobileDialogService = inject(MobileDialogService);
	private readonly offersFacade = inject(OffersFacade);

	clearAllFilters(): void {
		this.offersFacade.clearSelectedOptions();
		this.offersFacade.reloadOfferList();
	}

	closeDialog(): void {
		this.mobileDialogService.shouldScroll$.next(true);
		this.mobileDialogService.close();
	}
}
